import { render, staticRenderFns } from "./crudPopups.vue?vue&type=template&id=e898231e&"
import script from "./crudPopups.vue?vue&type=script&lang=js&"
export * from "./crudPopups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports